import Main from './Main.vue'
import Lista from './components/ListaGrvs'
import Grv from './components/Grv'
import GrvPatio from './components/GrvPatio'
import Pericia from './components/Pericia'
import Ggv from './components/Ggv'
import Gev from './components/Gev'
import CadastroNotificacaoProcesso from './cadastro-notificacao-processo/routes'
import CadastroNotificacaoTelegrama from './cadastro-notificacao-telegrama/routes'
import LocalizacaoVeiculo from './components/LocalizacaoVeiculo'

export default [{
  path: 'roubo-furto',
  name: 'roubo-furto',
  component: Main,
  children: [
    {path: '/', component: Lista, name: 'roubo-furto.list'},
    {path: 'localizacao-veiculo', component: LocalizacaoVeiculo, name: 'roubo-furto-localizacao-veiculo'},
    {path: 'registrar', component: Grv, name: 'roubo-furto.novo'},
    {path: ':id', component: Grv, name: 'roubo-furto.visualizar'},
    {path: 'ggv/:id', component: Ggv, name: 'roubo-furto.visualizar.ggv'},
    {path: 'gev/:id', component: Gev, name: 'roubo-furto.visualizar.gev'},
    {path: 'patio/:id', component: GrvPatio, name: 'roubo-furto.visualizar.patio'},
    {path: 'pericia/registrar', component: Pericia, name: 'roubo-furto.pericia.registrar'},
    {path: 'pericia/:id', component: Pericia, name: 'roubo-furto.pericia.update'},
    ...CadastroNotificacaoProcesso,
    ...CadastroNotificacaoTelegrama
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/roubo-furto/routes.js